export enum PDF_DOCUMENT_TYPE {
  MEDIA_PACK = 'mediaPack',
  CONTENT = 'content',
  TIKTOK_CONTENT = 'tiktokContent',
  YOUTUBE_CONTENT = 'youtubeContent',
}
